import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20abstract%20gradient%20background%20with%20gentle%20flowing%20waves%20of%20cream%20beige%20and%20warm%20golden%20tones%2C%20minimalist%20artistic%20texture%2C%20dreamy%20ethereal%20atmosphere%2C%20calming%20meditative%20aesthetic&width=1800&height=800&seq=cta-bg-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-6">
          准备好开启你的
          <br />
          专属解压音频世界了吗？
        </h2>
        <p className="text-base md:text-lg text-background-50/80 mb-10 max-w-xl mx-auto leading-relaxed">
          加入超过 50 万用户，用 asmrone 的声音治愈你的每一天。免费探索，即刻开始。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/whisper"
            className="px-8 py-3.5 rounded-full text-base font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            立即免费体验
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 rounded-full text-base font-medium bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 hover:bg-background-50/25 transition-all whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}